import React from 'react';
import PropTypes from 'prop-types';

import {
  Typography,
} from '@material-ui/core';
import SubLoader from 'components/SubLoader';
import CommonModal from 'components/Modals/CommonModal';

const RemoveModal = ({ visible, onConfirm, onClose, description, loading, title }) => {
  
  return (
    <CommonModal
      open={visible}
      onClose={onClose}
      title={title || "Remove"}
      buttonLabel="CONFIRMER"
      btnDisabled={false}
      onSubmit={onConfirm}
    >
      {loading && <SubLoader />}
      <Typography>{description}</Typography>
    </CommonModal>
  );
};

RemoveModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string
};

export default RemoveModal;
